import { render } from "./SaveSubSuccessNot.vue?vue&type=template&id=2e99c8c8"
import script from "./SaveSubSuccessNot.vue?vue&type=script&lang=js"
export * from "./SaveSubSuccessNot.vue?vue&type=script&lang=js"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__